import { ChildProps } from "ts/types";

export default function Container({ children }: ChildProps) {
  return (
    <div className="h-full overflow-auto rounded-2.5xl bg-white">
      {children}
    </div>
  );
}
